<template>
    <div class="model-interests" @click="setActive">
        <div ref="parentField" class="model-interests__field">
            <svg
                width="12"
                height="6"
                viewBox="0 0 12 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="model-interests__arrow"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 0H12L6 6L0 0Z"
                    fill="#98A0A9"
                />
            </svg>

            <span
                class="model-interests__label"
                :class="{
                    'model-interests__label--state--active': isFilled,
                }"
                :data-voicetext="label"
            >
                {{ label }}
            </span>

            <div
                v-for="(item, i) in selected"
                :key="`${i}${item}`"
                class="model-interests__chip"
                :data-voicetext="setSelectedChip({ item: item })"
                @click.stop="removeItem(i)"
            >
                {{ setSelectedChip({ item: item }) }}
                <svg
                    width="8"
                    height="9"
                    viewBox="0 0 8 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="model-interests__delete-icon"
                >
                    <path
                        d="M1 7.5L7 1.5"
                        stroke="#251F45"
                        stroke-width="1.3"
                        stroke-linecap="round"
                    />
                    <path
                        d="M7 7.5L1 1.5"
                        stroke="#251F45"
                        stroke-width="1.3"
                        stroke-linecap="round"
                    />
                </svg>
            </div>
        </div>

        <div
            class="model-interests__drop-down"
            :class="{
                'model-interests__drop-down--state--active': isActive,
            }"
        >
            <input
                type="text"
                ref="vinput"
                class="model-interests__input"
                placeholder="Введите свое улечение"
                @input="typeExtended"
                @blur="blurClose"
                :maxlength="maxLength"
                autocomplete="off"
            />
            <div
                v-if="maxLength"
                class="model-interests__counter-wrapper"
                :class="{
                    'model-interests__counter-wrapper--state--warning':
                        isWarning,
                }"
            >
                <span v-if="isWarning" class="model-interests__warning-text">
                    {{ maxLengthTextError }}
                </span>
                <div class="model-interests__counter-inner">
                    <span class="model-interests__counter">{{
                        typedSymbalsCount
                    }}</span
                    >/<span class="model-interests__counter">{{
                        maxLength
                    }}</span>
                </div>
            </div>

            <div class="model-interests__items-wrapper">
                <div
                    v-for="(item, i) in selectedExtended"
                    :key="item.title"
                    class="model-interests__items-item"
                    @mousedown.prevent="
                        removeExtendedItem({ title: item.title, i: i })
                    "
                >
                    <span
                        class="model-interests__checkbox"
                        :class="{
                            'model-interests__checkbox--state--selected':
                                checkExtendedActive(item),
                        }"
                        :data-voicetext="item.title"
                    ></span>
                    {{ item.title }}
                </div>
                <div
                    v-for="(item, i) in search"
                    :key="`${i}${item}`"
                    class="model-interests__items-item"
                    :class="{
                        'model-interests__items-item--state--selected':
                            selected.findIndex((s) => item == s) > -1,
                    }"
                    :data-voicetext="allInterests.find((x) => x.id === item.id).field_value"
                    @mousedown.prevent="choseItem($event, { item: item })"
                >
                    <span
                        class="model-interests__checkbox"
                        :class="{
                            'model-interests__checkbox--state--selected':
                                showActiveIcon(item),
                        }"
                    >
                    </span>
                    {{ allInterests.find((x) => x.id === item.id).field_value }}
                </div>

                <div
                    v-if="isNotFounded"
                    class="model-interests__items-item"
                    :class="{
                        'model-interests__items-item--state--disabled':
                            !canChoseItem,
                    }"
                    :data-voicetext="inputValue"
                    @mousedown.prevent="
                        choseExtendedItem($event, { value: inputValue })
                    "
                >
                    <span class="model-interests__checkbox"></span>
                    {{ inputValue }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from '@/tools/debounce';

export default {
    name: 'ModelInterests',
    props: {
        label: String,
        items: {
            type: Array,
            default: () => [],
        },
        selected: {
            type: Array,
            default: () => [],
        },
        allInterests: {
            type: Array,
            default: () => [],
        },
        value: [Array, Object],
        maxLength: Number,
        search: {
            type: Array,
            default: () => [],
        },
        lastItem: {
            type: Object,
            default: () => {},
        },
        maxLengthTextError: String,
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    data: () => ({
        isActive: false,
        typedSymbalsCount: 0,
        isWarning: false,
        inputValue: null,
        canChoseItem: true,
        selectedChip: '',
        selectedExtended: [],
    }),
    computed: {
        isFilled() {
            return (
                this.isActive ||
                (this.selected && this.selected.length) ||
                (this.value && this.value.length)
            );
        },
        isNotFounded() {
            return this.search.length == 0;
        },
    },
    watch: {
        isActive(v) {
            if (v) {
                this.$nextTick(() => {
                    if (this.$refs.vinput) {
                        this.$refs.vinput.focus();
                    }
                });
            }
        },
    },
    methods: {
        setActive() {
            this.isActive = true;
        },
        blurClose() {
            setTimeout(() => {
                this.isActive = false;
            }, 350);
        },
        completeInputs: debounce(function (e) {
            this.$emit('debounce-end', {
                value: e.target.value,
            });
        }, 1000),
        typeExtended(e) {
            this.completeInputs(e);
            let inputValue = e.target.value;
            this.inputValue = e.target.value.substring(0, this.maxLength);
            this.typedSymbalsCount = inputValue.length;
            if (this.maxLength && e.target.value.length >= this.maxLength) {
                this.isWarning = true;
            } else {
                this.isWarning = false;
            }
        },
        choseItem($event, { item }) {
            let index = this.selected.findIndex((s) => s.rsvDataId == item.id);
            this.$refs.vinput.value = null;
            if (index >= 0) {
                this.removeItem(index);
            } else {
                this.selected.push({
                    title: null,
                    rsvDataId: item.id,
                });
                this.emitValue($event, item);
            }
        },
        emitValue(e, item) {
            this.$emit(
                'change',
                this.selected.map((s) => s)
            );
        },
        choseExtendedItem($event, { value }) {
            this.isWarning = false;
            this.typedSymbalsCount = 0;

            if (this.canChoseItem) {
                this.$refs.vinput.value = null;
                this.selected.push({
                    title: value,
                    rsvDataId: null,
                });
                this.selectedExtended.unshift({
                    title: value,
                    rsvDataId: null,
                });
            }

            this.$emit('debounce-end', {
                value: '',
            });

            this.emitValue($event, value);
        },
        removeItem(index) {
            this.selected.splice(index, 1);
            this.$emit(
                'change',
                this.selected.map((s) => s)
            );
        },
        removeExtendedItem({ title, i }) {
            const index = this.selected.findIndex(
                (prop) => prop.title === title
            );

            this.selectedExtended.splice(i, 1);
            this.selected.splice(index, 1);
            this.$emit(
                'change',
                this.selected.map((s) => s)
            );
        },
        setSelectedChip({ item }) {
            if (!item.title) {
                return this.allInterests.find((x) => x.id == item.rsvDataId)
                    .field_value;
            }

            return item.title;
        },
        showActiveIcon(item) {
            if (!item.id) {
                return (
                    this.selected.findIndex(
                        (s) => s.field_value == item.title
                    ) > -1
                );
            }

            if (!item.title) {
                return (
                    this.selected.findIndex((s) => s.rsvDataId == item.id) > -1
                );
            }

            return false;
        },
        checkExtendedActive(item) {
            return (
                this.selectedExtended.findIndex((s) => s.title == item.title) >
                -1
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mt';
@import '~@/styles/mrem';
.model-interests {
    position: relative;
    display: flex;
    align-items: center;

    &__field {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #98a0a9;
        border-radius: mrem(10);
        padding: mrem(11) mrem(52) mrem(11) mrem(16);
        min-height: mrem(48);
        margin-bottom: mrem(16);
        margin-top: mrem(16);
        @include on-desktop {
            display: flex;
            flex-wrap: wrap;
            border-width: rem(1);
            border-radius: rem(10);
            padding: rem(11) rem(52) rem(11) rem(16);
            margin-bottom: rem(16);
            margin-top: rem(16);
            min-height: rem(48);
            cursor: pointer;
        }

        &::placeholder {
            color: #98a0a9;
        }

        &:focus {
            &::placeholder {
                color: transparent;
            }
        }
    }

    &__arrow {
        position: absolute;
        top: mrem(32);
        right: mrem(20);
        width: mrem(16);
        height: mrem(16);
        transform: rotate(0);
        z-index: 4;

        @include on-desktop {
            top: rem(34);
            right: rem(24);
            width: rem(14);
            height: rem(14);
        }
    }

    &__label {
        position: absolute;
        left: mrem(10);
        padding: mrem(2) mrem(8);
        font-weight: 400;
        font-size: mrem(16);
        line-height: mrem(24);
        color: #98a0a9;
        background: #fff;

        @include on-desktop {
            top: rem(26);
            font-size: rem(16);
            line-height: rem(24);
            left: rem(10);
            padding: rem(2) rem(8);
        }

        &--state {
            &--active {
                top: mrem(4);
                font-weight: 600;
                font-size: mrem(12);
                color: #4663ab;
                @include on-desktop {
                    top: rem(4);
                    font-size: rem(12);
                }
            }
        }
    }

    &__drop-down {
        position: absolute;
        display: none;
        width: 100%;
        padding: mrem(16);
        background: #fff;
        box-shadow: mrem(0) mrem(2) mrem(16) rgba(107, 116, 123, 0.25);
        border-radius: 10px;
        top: mrem(32);
        left: mrem(12);
        z-index: 9;

        @include on-desktop {
            top: rem(30);
            left: rem(10);
            padding: rem(16);
            box-shadow: rem(0) rem(2) rem(16) rgba(107, 116, 123, 0.25);
        }

        &--state {
            &--active {
                display: block;
            }
        }
    }

    &__input {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #d2d5d9;
        border-radius: mrem(10);
        padding: mrem(12) mrem(16);
        margin-bottom: mrem(6);
        @include on-desktop {
            border-width: rem(1);
            border-radius: rem(10);
            padding: rem(12) rem(16);
            margin-bottom: rem(6);
            margin-top: rem(16);
        }

        &--state {
            &--warning {
                border-color: red;
            }
        }

        &::placeholder {
            color: #98a0a9;
        }

        &:focus {
            &::placeholder {
                color: transparent;
            }
        }
    }

    &__counter-wrapper {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: mrem(20);

        @include on-desktop {
            margin-bottom: rem(20);
        }

        &--state {
            &--warning {
                span {
                    color: red;
                }
                color: red;
            }
        }
    }

    &__counter-inner {
        position: absolute;
        top: 0;
        right: 0;
        @include on-desktop {
            top: rem(1);
            right: 0;
        }
    }

    &__warning-text {
        font-weight: 400;
        font-size: mrem(14);
        line-height: mrem(18);

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(18);
        }
    }

    &__items-wrapper {
        overflow-y: scroll;
        max-height: 30vh;
        @include custom-scroll-bar;
        margin-right: mrem(-4);

        @include on-desktop {
            margin-right: rem(-16);
        }
    }

    &__counter {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #98a0a9;
    }

    &__items-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: 400;
        font-size: mrem(16);
        line-height: mrem(21);
        padding: mrem(8) 0;

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(21);
            padding: rem(8) 0;
            cursor: pointer;
        }

        &--state {
            &--active {
                color: #4663ab;
            }

            &--selected {
                color: #4663ab;
            }

            &--disabled {
                opacity: 0.5;
                pointer-events: none;
            }
        }
    }

    &__items-icon {
        width: mrem(22);
        height: mrem(22);
        @include on-desktop {
            width: rem(22);
            height: rem(22);
        }
    }

    &__checkbox {
        width: mrem(18);
        height: mrem(18);
        min-width: mrem(18);
        min-height: mrem(18);
        border: mrem(2) solid #98a0a9;
        border-radius: mrem(4);
        margin-right: mrem(8);
        @include on-desktop {
            width: rem(18);
            height: rem(18);
            min-width: rem(18);
            min-height: rem(18);
            margin-right: rem(8);
            border: rem(2) solid #98a0a9;
            box-sizing: border-box;
            border-radius: rem(4);
        }

        &--state {
            &--selected {
                border-color: #4663ab;
                background-color: #4663ab;
                background-image: url('~@/assets/images/icons/checkbox.svg');
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 85%;
            }
        }
    }

    &__chip {
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: mrem(14);
        line-height: mrem(20);
        padding: mrem(8) mrem(34) mrem(8) mrem(18);
        margin: mrem(4) mrem(8) mrem(4) 0;
        background: #e3edff;
        border-radius: mrem(10);
        @include on-desktop {
            justify-content: center;
            font-size: rem(14);
            line-height: rem(20);
            padding: rem(8) rem(34) rem(8) rem(18);
            margin: rem(4) rem(8) rem(4) 0;
            border-radius: rem(10);
        }
    }

    &__delete-icon {
        position: absolute;
        right: mrem(18);
        width: mrem(12);
        height: mrem(12);
        @include on-desktop {
            right: rem(12);
            width: rem(12);
            height: rem(12);
        }
    }
}
</style>
